/* eslint-disable react/no-deprecated */
import React from 'react';
import './LaunchingForm.styles.css';
import { withStyles } from '@material-ui/core/styles';
import { Form } from 'react-bootstrap';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from '../Modal';
import { openErrorModal } from '../../actions';
import { KEYWORDS, TYPES } from '../../constants';
import Input from '../Input';
import Select from '../Select';
import {
  onChangeShopData,
  onChangeConfigData,
  handleSelectAddressCompany,
  handleSelectAddressShop,
  onChangeData,
  handleSubmit,
  onChangeKeywords,
  handleChangePhoneNumber
} from './LaunchingForm.services';
import { phoneNumberMinLength, formatPhoneService } from '../../utils/shopUtils';
import ReactPhoneInput from 'react-phone-input-2';
import { isStringNotNull } from '../../utils/tools';
import AddressSearchAutocompleteInput from '../AddressSearchAutocompleteInput/AddressSearchAutocompleteInput.view';
const styles = () => ({});
const initialState = {
  showLaunchingModal: false,
  addressCompany: '',
  addressShop: '',
  isLoadingData: false,
  legal: {
    companyType: ''
  },
  shop: {},
  configurations: {
    businessType: '',
    keyWords: ''
  },
  touched: false,
  chosenTechs: {
    webApp: true
  },
  validationMessage: {
    name: null,
    email: null,
    companyType: null,
    companyName: null,
    number: null,
    companyAddressError: null,
    shopAddressError: null,
    registreCommerceVille: null,
    registreCommerceNumero: null,
    capitalSocial: null,
    businessType: null
  }
};

class LaunchingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
  }

  componentWillMount() {
    this.setState({ showLaunchingModal: this.props.showLaunchingModal });
  }

  componentWillReceiveProps(props) {
    this.setState({ showLaunchingModal: props.showLaunchingModal });
  }

  renderInfoLegal = () => {
    const { legal, addressCompany, validationMessage } = this.state;
    const {
      companyName,
      registreCommerceVille,
      registreCommerceNumero,
      capitalSocial,
      companyType
    } = legal;
    return (
      <div className='mb-4'>
        <h4 className='mb-2 font-weight-bold'>Informations sur l&apos;entreprise</h4>
        <div className='mx-3'>
          <Form.Row>
            <Form.Group className='col mb-2'>
              <Input
                type='text'
                label="Nom de l'entreprise"
                id='companyName'
                placeholder='My shop'
                value={companyName}
                onChange={e => onChangeData(e, this)}
                error={validationMessage.companyName === 'is-invalid'}
                required
                fullWidth
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group className='col mb-2'>
              <AddressSearchAutocompleteInput
                typedAddress={addressCompany}
                setTypedAddress={(typedAddress) => this.setState((prevState) => ({ addressCompany: typedAddress, validationMessage: { ...prevState.validationMessage, companyAddressError: null } }))}
                handleAddressSelection={(selectedAddressValue, placeId) => handleSelectAddressCompany(selectedAddressValue, this)}
                handleAddressInputFormControlError={(
                  status,
                  clearSuggestions
                ) => null}
                hasErrorAddressMessage={false}
                inputElementRef={null}
                animatePlaceholder={''}
                isFilledAddressValid={validationMessage.companyAddressError === 'is-valid'}
                label={"Adresse de l'entreprise"}
              />
              <Form.Control.Feedback type='invalid'>
                Merci de bien séléctionner une des adresses proposées
              </Form.Control.Feedback>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group className='col mb-2 mr-3' md='6'>
              <Input
                label='Numéro de SIREN'
                type='text'
                id='registreCommerceNumero'
                placeholder='123456789'
                onChange={e => onChangeData(e, this)}
                value={registreCommerceNumero}
                error={validationMessage.registreCommerceNumero === 'is-invalid'}
                required
                fullWidth
              />
            </Form.Group>
            <Form.Group className='col ml-2 ml-3' md='6'>
              <div>
                <Select
                  as='select'
                  custom
                  className='w-100'
                  label="Type d'entreprise"
                  id='companyType'
                  onChange={e => onChangeData(e, this)}
                  value={companyType}
                  error={validationMessage.companyType === 'is-invalid'}
                  required
                  name='companyType'
                >
                  <option value='' disabled>
                    À choisir
                  </option>
                  {_.map(TYPES, type => {
                    return <option value={type}>{type}</option>;
                  })}
                </Select>
              </div>
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group className='col mb-2 mr-3' md='6'>
              <Input
                label='Capital social'
                type='number'
                id='capitalSocial'
                placeholder='500'
                value={capitalSocial < 0 ? 0 : capitalSocial}
                onChange={e => onChangeData(e, this)}
                error={validationMessage.capitalSocial === 'is-invalid'}
                required
                fullWidth
              />
            </Form.Group>
            <Form.Group className='col mb-2 ml-3' md='6'>
              <Input
                label="Ville d'immatriculation"
                type='text'
                fullWidth
                id='registreCommerceVille'
                placeholder='Nice'
                value={registreCommerceVille}
                onChange={e => onChangeData(e, this)}
                error={validationMessage.registreCommerceVille === 'is-invalid'}
                required
              />
            </Form.Group>
          </Form.Row>
        </div>
      </div>
    );
  };

  renderInfoShop = () => {
    const { addressShop, shop, validationMessage = {} } = this.state;
    const { name, email, number } = shop;
    let value = formatPhoneService(this, number);
    return (
      <div className=''>
        <h4 className='mb-2 font-weight-bold'>Informations sur le magasin</h4>
        <div className='mx-3'>
          <Form.Row>
            <Form.Group className='col mb-2'>
              <Input
                label='Nom du magasin'
                type='text'
                id='name'
                placeholder='My shop'
                value={name}
                onChange={e => onChangeShopData(e, this)}
                required
                fullWidth
                name='name'
                error={validationMessage.name === 'is-invalid'}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group className='col mb-2'>
              <AddressSearchAutocompleteInput
                typedAddress={addressShop}
                setTypedAddress={(typedAddress) => this.setState((prevState) => ({ addressShop: typedAddress, validationMessage: { ...prevState.validationMessage, shopAddressError: null } }))}
                handleAddressSelection={(selectedAddressValue, placeId) => handleSelectAddressShop(selectedAddressValue, this)}
                handleAddressInputFormControlError={(
                  status,
                  clearSuggestions
                ) => null}
                hasErrorAddressMessage={false}
                inputElementRef={null}
                animatePlaceholder={''}
                isFilledAddressValid={validationMessage.shopAddressError === 'is-valid'}
                label={'Adresse du magasin'}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group className='col mb-2'>
              <Input
                label='Email'
                type='text'
                id='email'
                fullWidth
                placeholder='prenom.nom@exemple.com'
                value={email}
                onChange={e => onChangeShopData(e, this)}
                required
                error={validationMessage.email === 'is-invalid'}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group className='col mb-3 mt-3'>
              <ReactPhoneInput
                placeholder='Téléphone'
                id='number'
                countryCodeEditable={false}
                inputStyle={{
                  width: '100%',
                  boxSizing: 'border-box',
                }}
                country='fr'
                value={value}
                preferredCountries={['fr', 'mc']}
                regions={['europe']}
                inputClass={`${(this.isPhoneIncorrect || !isStringNotNull(value)) ? 'is-invalid' : ''}`}
                ref={(node) => (this.phoneInput = node)}
                onChange={(phone) => handleChangePhoneNumber(formatPhoneService(this, phone), this)}
                isValid={(value, countryCode) => {
                  if (this.phoneInput) {
                    const { dialCode, iso2 } = countryCode;
                    const minLength = phoneNumberMinLength(iso2);
                    this.isPhoneIncorrect = (value.length - dialCode.length < minLength) || (value && value.toString().replace(dialCode, '')[0] === '0');
                  }
                  return true;
                }}
              />
              {((this.isPhoneIncorrect || !isStringNotNull(value)) && this.state.touched) && (
                <div className="invalid-feedback-block">Veuillez fournir un téléphone valide</div>
              )}
            </Form.Group>
          </Form.Row>
        </div>
      </div>
    );
  };

  renderInfoConfig = () => {
    const { configurations, chosenTechs, validationMessage } = this.state;
    const { businessType, keyWords } = configurations;

    return (
      <div className=''>
        <div className='mx-3'>
          <Form.Row>
            <Form.Group className='col mb-2'>
              <Select
                as='select'
                custom
                label='Type de magasin'
                id='businessType'
                onChange={e => onChangeConfigData(e, this)}
                defaultValue=''
                value={businessType}
                error={validationMessage.businessType === 'is-invalid'}
                required
                fullWidth
                name='businessType'
              >
                <option value='' disabled>
                  À choisir
                </option>
                {KEYWORDS &&
                  _.keys(KEYWORDS).map(key => (
                    <option key={key} value={key}>
                      {key}
                    </option>
                  ))}
              </Select>
            </Form.Group>
          </Form.Row>
          {/*
          <div className='form-group mb-2'>
            <label htmlFor='keyWords'>Choix technologique</label>
            <div style={{ border: '0.5px solid #ced4da', borderRadius: '4px' }} className='p-2'>
              {TECHNOLOGIES &&
                Object.keys(TECHNOLOGIES).map(key => (
                  <div className='form-check' key={key}>
                    <input
                      className={`${validationMessage.technoCheck} form-check-input form-checks`}
                      type='checkbox'
                      value={chosenTechs[key]}
                      id={key}
                      onClick={e => onChangeCheck(e, this)}
                    />
                    <label className='form-check-label' htmlFor='key'>
                      {TECHNOLOGIES[key]}
                    </label>
                  </div>
                ))}
            </div>
          </div>
        */}
          {chosenTechs.webApp ? (
            <Form.Row>
              <Form.Group className='col mb-2'>
                <Form.Label>Référencement</Form.Label>
                <Form.Control
                  type='text'
                  as='textarea'
                  required
                  aria-label='With textarea'
                  id='keyWords'
                  placeholder=''
                  value={keyWords}
                  onChange={e => onChangeKeywords(e, this)}
                />
              </Form.Group>
            </Form.Row>
          ) : null}
        </div>
      </div>
    );
  };

  render() {
    const { showLaunchingModal, isLoadingData } = this.state;
    return (
      <>
        <Modal
          isOpen={showLaunchingModal}
          title='Lancement de votre magasin'
          fixed
          header
          btnTxt='Enregistrer'
          showCancelBtn
          handleClose={() => {
            this.props.onClose();
            this.setState(initialState);
          }}
          onClick={e => handleSubmit(e, this)}
          loading={isLoadingData}
        >
          <>
            <Form>
              {this.renderInfoLegal()}
              {this.renderInfoShop()}
              {this.renderInfoConfig()}
            </Form>
          </>
        </Modal>
      </>
    );
  }
}

export default withStyles(styles)(connect(null, { openErrorModal })(LaunchingForm));
